import { Authenticator } from "@aws-amplify/ui-react";
import Header from "./components/Header";
import Body from "./components/Body";
import { MapProvider } from "./context/MapContext";
import { TohonBuyProvider } from "./context/TohonBuyContext";
import { AuthProvider } from "./context/AuthContext";
import PaymentSuccessOverlay from "./components/auth/PaymentSuccessOverlay";
import PaymentCancelOverlay from "./components/auth/PaymentCancelOverlay";

export default function App() {
  return (
    <Authenticator.Provider>
      <AuthProvider>
        <TohonBuyProvider>
          <MapProvider>
            <Header />
            <Body />
            <PaymentSuccessOverlay />
            <PaymentCancelOverlay />
          </MapProvider>
        </TohonBuyProvider>
      </AuthProvider>
    </Authenticator.Provider>
  );
}
